import {Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {
  startOfISOWeek,
  endOfISOWeek,
  startOfMonth,
  endOfMonth
} from 'date-fns';
import {CustomerService, TicketService, TimeService} from 'src/app/services';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {CallService} from '../../../services';
import {getDateHelper} from "../../../shared/common/helper";

@Component({
  selector: 'app-log-call-time',
  templateUrl: './log-call-time.component.html',
  styleUrls: ['./log-call-time.component.scss']
})
export class LogCallTimeComponent implements OnInit, OnDestroy {
  unsubscribe$ = new Subject();
  search$ = new Subject();
  customers = [];
  isLoading = false;
  customerId;
  callId;
  from;
  to;
  page = 1;
  pageSize = 10;
  query;
  // tslint:disable-next-line:variable-name
  now_month: any;
  ranges1: any;
  dateRange = [];
  // tslint:disable-next-line:variable-name
  list_id = [];
  data = [];
  loading = false;
  total = 0;
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  mapOfCheckedId = {};
  changeAction = undefined;

  unsubsribe$ = new Subject();
  defaultPhone: any = ""
  defaultToken: any = ""
  ownerPhone: any = ""
  ownerToken: any = ""
  selectedPhone: any = ""
  selectedToken: any = ""
  selectedCustomer: any = null
  userId: any = null

  // @ts-ignore
  @ViewChild('noteModal') noteModal;
// @ts-ignore
  @ViewChild('call') call;
  constructor(
    private timeService: TimeService,
    private notification: NzNotificationService,
    private customerService: CustomerService,
    private ticketService: TicketService,
    private callService: CallService,
  ) {
    this.search$.asObservable().pipe(
      debounceTime(500),
    ).subscribe(
      res => {
        const query = {
          keyword: res
        };
        this.customerService.list(query).pipe(takeUntil(this.unsubscribe$)).subscribe(
          response => {
            if (response.code === 1) {
              this.customers = response.data.items;
            }
          }
        );
      }
    );
  }

  ngOnInit() {
    const x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 1);
    this.now_month = x;
    this.ranges1 = {
      'Hôm nay': [new Date(), new Date()],
      'Hôm qua': [new Date(new Date().getTime() - 24 * 60 * 60 * 1000), new Date(new Date().getTime() - 24 * 60 * 60 * 1000)],
      'Tuần trước': [new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000), new Date()],
      'Tuần này': [startOfISOWeek(new Date()), endOfISOWeek(new Date())],
      'Tháng trước': [startOfMonth(new Date(this.now_month)), endOfMonth(new Date(this.now_month))],
      '30 ngày gần nhất': [new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000), new Date()],
    };
    this.loadData();
    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    this.getClientToken()
    this.searchCustomer("")
  }
  searchCustomer(event) {
    this.search$.next(event);
  }
  loadData() {
    this.loading = true;
    this.query = {
      page: this.page,
      page_size: this.pageSize,
      callId: this.callId || "",
      from: this.from || "",
      to: this.from || "",
      customerId: this.customerId || ""
    };
    this.timeService.getList(this.query).pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        this.loading = false;
        console.log(123)
        if (res.code === 1) {
          res.data.items.map(item => {
            if (item.answerAt !== 0) {
              // nghe may
              const timeStart = new Date(item.startAt).getTime();
              const timeAnswer = new Date(item.answerAt).getTime();
              const timePending = (timeAnswer - timeStart) / 1000;
              item.timePending = this.convertTimePending(timePending);
              const timeEnd = new Date(item.endAt).getTime();
              const timeCall = (timeEnd - timeAnswer) / 1000;
              const minute = Math.floor(timeCall / 60);
              const seconds = timeCall - minute * 60;
              const hours = Math.floor(minute / 60);
              let minuteAfterSetHour = 0;
              if (hours) {
                minuteAfterSetHour = minute - 60 * hours;
              } else {
                minuteAfterSetHour = minute;
              }
              const s =  seconds < 10 ? `0${seconds}` : `${seconds}`;
              const m  = minuteAfterSetHour < 10 ? `0${minuteAfterSetHour}` : `${minuteAfterSetHour}`;
              const h = hours < 10 ? `0${hours}` : hours;
              if (hours) {
                item.timeCall = h + ':' + m + ':' + s;
              } else {
                item.timeCall = m + ':' + s;
              }
            } else {
              // khong nge may
              const timeStart = new Date(item.startAt).getTime();
              const timeEnd = new Date(item.endAt).getTime();
              const timePending = (timeEnd - timeStart) / 1000;
              item.timePending = this.convertTimePending(timePending);
              item.timeCall = `00:00`;
            }
          });
          this.data = res.data.items;
          this.total = res.data.totalElement;
          return;
        }
        this.notification.error(
          'Có lỗi xảy ra',
          res.message
        );
      },
      error => {
        console.log(error);
        this.loading = false;
        this.notification.error(
          'Có lỗi xảy ra',
          error
        );
      }
    );
  }
  convertTimePending(timePending) {
    if (timePending >= 60) {
      const m$ = Math.floor(timePending / 60);
      const s$ =  timePending - m$ * 60;
      // tslint:disable-next-line:variable-name
      const m$_converted = `0${m$}`;
      // tslint:disable-next-line:variable-name
      const s$_converted = s$ <  10 ? `0${s$}` : `${s$}`;
      return m$_converted + ':' + s$_converted;
    } else {
      return timePending < 10 ? `00:0${timePending}` :  `00:${timePending}`;
    }
  }
  onChange(event) {
    if (event.length === 2) {
      const from = this.getDate(event[0], 'start');
      const to = this.getDate(event[1], 'end');
      this.from = new Date(from).getTime();
      this.to = new Date(to).getTime();
    }
  }

  search() {
    this.page = 1;
    this.loadData();
  }

  reset() {
    const arr = [ 'callId', 'customerId', 'from', 'to'];
    arr.map(key => {
      this[key] = undefined;
    });
    this.dateRange = [];
    this.page = 1;
    this.mapOfCheckedId = {};
    this.loadData();
  }
  createCall(data) {
    const type = data.customerId !== undefined;
    const body = {
      id: data.customerId,
      name: data.customerName,
      email: data.customerEmail,
      phone: data.customerPhone,
      avatar: data.customerAvatar
    };
    const clientToken = {
      phone: this.selectedPhone,
      token: this.selectedToken,
      userId : this.userId
    };
    this.call.showModal(body, type, clientToken);
  }
  afterCall(event) {
    this.loadData();
  }
  actionsButton(event) {
    // console.log(event);
  }

  buttonSubmit() {
  }

  checkAll(value: boolean) {
    this.data.forEach(item => (this.mapOfCheckedId[item.callId] = value));
    this.refreshStatus();
  }

  refreshStatus() {
    if (this.data.length > 0) {
      this.isAllDisplayDataChecked = this.data.every(item => this.mapOfCheckedId[item.callId]);
    } else {
      this.isAllDisplayDataChecked = false;
    }
    this.isIndeterminate = this.data.some(item => this.mapOfCheckedId[item.callId]) && !this.isAllDisplayDataChecked;
    for (const key in this.mapOfCheckedId) {
      if (this.mapOfCheckedId[key] === true) {
        if (!this.list_id.includes(key)) {
          this.list_id.push(key);
        }
      } else {
        if (this.list_id.includes(key)) {
          this.list_id.splice(this.list_id.indexOf(key), 1);
        }
      }
    }
    console.log(this.list_id);

  }

  openModalNote(data: any) {
    if (data.ticketId === null) {
      const callId = data.callId;
      this.noteModal.showNote(callId, 'create');
      return;
    }
    this.ticketService.detailTicket(data.ticketId).pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        if (res.code === 1) {
          this.noteModal.showNote(res.data, 'update');
        }
      }
    );
  }
  updateTicket(event) {
    let body: any;
    if (event.type === 'create') {
      body = event.value;
      body.callId =  event.callId;
      body.customerId = event.customerId;
      this.callService.saveTicket(body).pipe(takeUntil(this.unsubscribe$)).subscribe(
        res => {
          if (res.code === 1) {
            this.notification.success(
              'Thành công',
              'Tạo ghi chú thành công'
            );
            this.noteModal.hideNote();
            this.loadData();
            return;
          }
          this.notification.error(
            'Tạo ghi chú thất bại',
            res.message
          );
        },
        error => {
          this.notification.error(
            'Tạo ghi chú thất bại',
            error.message
          );
        }
      );
      return;
    }
    body = event.value;
    body.id = event.id;
    this.ticketService.updateTicket(body).pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        if (res.code === 1) {
          this.noteModal.hideNote();
          this.notification.success(
            'Thành công',
            'Cập nhật ghi chú thành công'
          );
          this.loadData();
          return;
        }
        this.notification.error(
          'Cập nhật thất bại',
          res.message
        );
      },
      error => {
        this.notification.error(
          'Cập nhật thất bại',
          error.message
        );
      }
    );
  }
  getDate(date, type: string) {
    return getDateHelper(date, type)
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getClientToken() {
    this.callService.getClientToken().pipe(takeUntil(this.unsubsribe$)).subscribe(
      res => {
        if (res.code === 1) {
          this.defaultPhone = res.data.default && res.data.default.phoneNumber ? res.data.default.phoneNumber : '';
          this.defaultToken = res.data.default && res.data.default.token ? res.data.default.token : '';
          this.ownerPhone = res.data.own && res.data.own.phoneNumber ? res.data.own.phoneNumber : '';
          this.ownerToken = res.data.own && res.data.own.token ? res.data.own.token : '';
          this.userId = res.data.userId;
          this.selectedPhone = this.defaultPhone ? this.defaultPhone : this.ownerPhone;
          this.selectedToken = this.defaultToken ? this.defaultToken : this.ownerToken;
        }
      }
    );
  }
}
